module.exports = __webpack_public_path__ + "img/fixed_block_bg.6fb32190.jpg";